import {
  observable,
  action
} from 'mobx';
import base from '../../tool/base';
import {
  message
} from 'antd';
import {
  toJS
} from 'mobx';
import {
  InitStore
} from "../init/InitStore";
import util from '../../util/index';
import { reject } from 'promise';
const {
  getAccessToken,
  catchApiError,
} = util;

const types = {
  'all': '全部应用',
  'workflow': '流程表单',
  'theme': '门户主题',
  'mode': 'E9建模模板',
  'docViewTemplate': '文档显示模板',
  'dev': '定制开发',
  // 'nStandard': '非标应用',
  'case': '开发案例',
  'app': '开发应用',
  'workflowStyle': '流程样式',
  'workflowChart': '流程表单',
};

const initState = {
  appShare: {
    visible: false,
    title: '分享表单',
    trade: '',
    function: '',
    otherTrade: '',
    otherFunction: '',
    name: '',
    sw_ids: [],
    fileList: [],
    selectedRowKeys: [],
    selectedRows: [],
    dataSource: [],
    dataSourceForTable: [],
    tradeName: '',
    functionName: '',
    pageSize: 10,
  },
  allPageParams: {
    pageNum: 1,
    pageSize: 12,
  },
  allDatas: {},
  allCount: 0,
  demotype: "code",
};
const initApplyModal = {
  visible: false,
  title: "表单获取",
  loading: false,
  appId: '',
  appName: ''
}

export class HomeStore {
  sss = 2;
  routing = null;
  @observable test = 1;
  @observable type = {
    id: "all",
    name: "全部应用"
  };
  @observable categoryDatas = [];
  @observable functionDatas = {
    key: 'functionNav',
    name: '职能',
    data: []
  }; //全部职能
  @observable appHot = [];
  @observable funcApplication = {
    "key": "function",
    "name": "职能应用",
    "img": "../../img/apply.png",
    "data": {}
  };
  @observable tradeApplication = {
    "key": "trade",
    "name": "行业应用",
    "img": "../../img/apply.png",
    "data": {}
  };
  @observable styleApplication = {
    "key": "style",
    "name": "样式应用",
    "img": "../../img/apply.png",
    "data": {}
  };
  @observable industry = {};
  @observable userCount = 1146;
  @observable funcAppData = [];
  @observable tradeAppData = [];
  @observable appHotSelected = '';
  @observable applyApps = {
    flow4AppAll: '',
    flow4App: ''
  };
  @observable applyModal = initApplyModal;
  @observable functionSelected = '';
  @observable subNavigation = [];
  @observable loading = false;
  @observable appShare = initState.appShare;
  @observable navPage = 1; //首页导航翻页
  @observable lastestShare = [];
  @observable initTypes = types;
  @observable appCount = 0;
  @observable addCollectLoading = false;
  @observable allDatas = initState.allDatas;
  @observable allCount = initState.allCount;
  @observable allLoading = false;
  @observable demoTypeObj = {};
  @observable demotype = initState.demotype;
  @observable allPageParams = initState.allPageParams;

  //-------------------------------------------------
  constructor(routing) {
    // 设置初始化选择的页面
    const typeStr = window.location.hash.match(/(\?|&)?id\=\w+&?/ig);
    let typeId = 'workflow';
    if (typeStr) typeId = typeStr[0].split('=')[1];
    this.type = {
      id: typeId,
      name: types[typeId],
    }
    this.routing = routing;
    this.getAppHot = this.getAppHot.bind(this);
    this.getKey = this.getKey.bind(this);
    this.setTradeApplication = this.setTradeApplication.bind(this);
    this.getLastestShare = this.getLastestShare.bind(this);
    this.getApplication = this.getApplication.bind(this);
    this.setType = this.setType.bind(this);
  }

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }

  @action
  doInitApplyModal = () => {
    this.applyModal = initApplyModal;
  }
  @action
  setType(type, typeName) {
    this.type = {
      id: type,
      name: typeName
    };
  }

  @action
  initPage = () => {
    this.allPageParams = initState.allPageParams;
  }

  @action
  initAllDatas = () => {
    this.allDatas = initState.allDatas;
    this.allCount = initState.allCount;
    this.demotype = initState.demotype;
    this.initPage();
  }

  @action
  clearAppHot = () => {
    this.appHot = [];
    this.appCount = 0;
  }
  
  callCategoryData = id => {
    this.getCategory();
    this.getUserCount();
    // this.getAppHot();
    // this.getTabs()
  }

  getKey() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  getCategory(params = {}) {
    base.callApi('/v3/genre?cloudStore=1', 'GET', {}, 'json', 'text').then((data) => { //1、获取顶部导航
      let tempSreenDatas = data.data;
      //去除“全部”数值
      tempSreenDatas.forEach(temp => {
        temp.data.forEach(v => {
          v.data.forEach((o, i) => {
            if (o.key === '0') {
              v.data.splice(i, 1);
            }
            v.data[i].funcList.splice(0, 1);
            this.functionDatas.data = this.functionDatas.data.concat(v.data[i].funcList);
          })
        });
      });
      this.categoryDatas = tempSreenDatas;
    }).then(() => { //2、获取热门应用
      let access_token = '';
      if (!!localStorage.me) {
        let me = !!localStorage.me ? JSON.parse(localStorage.me) : {
          role: ""
        };
        access_token = me.token.access_token;
      }
      let id = this.type.id;
      let kv = id === 'all' ?
        "-1" :
        id === 'workflow' ?
        "1" :
        id === 'portal' ?
        "2" :
        "-1";
      let params = {
        type: 1, //1：热门
        current: 1,
        offset: 0,
        pageSize: 6,
        kind: kv,
        cloudStore: 1,
        access_token: access_token,
      }
      base.callApi('/v3/app', 'POST', params, 'json', 'text').then((data) => {
        this.appHot = data.apps;
      }).then(() => { //3、获取类别导航
        this.getTabs()
      }).then(() => { //4、获取各类别应用
        this.getApplication(this.funcApplication, 'function');
        this.getApplication(this.tradeApplication, 'trade');
      });
    });
  }

  //获取用户数
  getUserCount() {
    base.callApi('/v3/getUserCount?cloudStore=1', 'GET', {}, 'json', 'text').then((data) => {
      data.data ? this.userCount = data.data : "";
    });
  }

  //获取热门
  getAppHot = (params = {}) => {
    let access_token = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : {
        role: ""
      };
      access_token = me.token.access_token;
    }
    let id = this.type.id;
    let kv = id === 'all' ?
      "-1" :
      id === 'workflow' ?
      "1" :
      id === 'portal' ?
      "2" :
      "-1";
    const _params = {
      type: 1, //1热门
      current: 1,
      offset: 0,
      pageSize: 6,
      kind: kv,
      cloudStore: 1,
      access_token: access_token,
    }
    params = params ? {
      ..._params,
      ...params,
      access_token: access_token,
    } : _params;
    base.callApi('/v3/app', 'POST', params, 'json', 'text').then((data) => {
      this.appHot = data.apps;
      this.appCount = data.count;
    });
  }

  //获取类别导航
  getTabs() {
    if (this.type.id === "workflow" || this.type.id === "all") {
      this.categoryDatas.forEach((o) => {
        if (o.key === 'workflow') {
          o.data.forEach((o2) => {
            if (o2.key === 'function') {
              this.funcApplication.tabs = o2.data;
            } else if (o2.key === 'trade') {
              this.tradeApplication.tabs = o2.data;
            }
          })
        } else if (o.key === 'portal') {
          o.data.forEach((o2) => {
            if (o2.key === 'style') {
              this.styleApplication.tabs = o2.data;
            }
          })
        }
      });
    }
  }

  //获取各类别热门应用
  getApplication = (application, secDir) => { //目前只有流程有职能和行业
    let access_token = '';
    if (!!localStorage.me) {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : {
        role: ""
      };
      access_token = me.token.access_token;
    }
    let tempData = [...application.data];
    let id = this.type.id;
    let kv = id === 'all' ?
      "-1" :
      id === 'workflow' ?
      "1" :
      id === 'portal' ?
      "2" :
      "-1";
    let f = "";
    application.tabs && application.tabs.map((o) => {
      let params = {
        type: 1, //1热门 2
        current: 1,
        offset: 0,
        pageSize: 6,
        kind: kv,
        cloudStore: 1,
        access_token: access_token,
      }
      secDir === 'function' ?
        params.function = o.key :
        secDir === 'trade' ?
        params.trade = o.key :
        "";
      base.callApi('/v3/app', 'POST', params, 'json', 'text').then((data) => {
        let temp = {
          "key": o.key,
          "data": (data.apps.length === 0 ? this.appHot : data.apps)
        }; //兼容没有数据时用热门
        tempData.push(temp);
        application.data = tempData;
      });
    });
    application.selectedKey = application.tabs && application.tabs.length > 0 && application.tabs[0].key;
  }

  renderCollectState(param = {}, type) {
    const ids = param.s_ids.split(',');
    ids.forEach(v => {
      switch (type) {
        case 'appHot':
          this.appHot.forEach((item, index) => {
            if (item.sw_id === v) {
              if (item.tms_iscoll === '1') {
                this.appHot[index].tms_iscoll = '0';
              } else {
                this.appHot[index].tms_iscoll = '1';
              }
            }
          })
        case 'category':
          this.tradeApplication.data.forEach((item, index) => {
            item = toJS(item);
            item.data.forEach((o, l) => {
              if (o.sw_id === v) {
                if (o.tms_iscoll === '1') {
                  this.tradeApplication.data[index].data[l].tms_iscoll = '0';
                } else {
                  this.tradeApplication.data[index].data[l].tms_iscoll = '1';
                }
              }
            })
          })
      }
    })
  }

  callCollect(param, type, type2) {
    let collect = type2 === 'collect' ? 0 : 1;
    let params = {
      collect: collect,
      access_token: getAccessToken(),
      cloudStore: 1,
      ...param,
    };
    base.callApi('/v3/appcollect/edit4batch', 'POST', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
      message.config({
        top: 20
      });
      if (data.status === 'true') {
        message.success(type2 === 'collect' ? '收藏成功' : '取消成功');
        this.renderCollectState(param, type);
      } else {
        message.success(data.msg ? data.msg : type2 === 'collect' ? '收藏失败，请重试！' : '取消失败，请重试！');
        localStorage.removeItem('me');
        InitStore.me = {};
      }
    });
  }

  callApply(params, appInfo) {
    params.orderType = '3';
    let param = {
      order: JSON.stringify(params),
      access_token: getAccessToken(),
      cloudStore: 1,
    };
    this.applyModal = {
      ...this.applyModal,
      visible: true,
      loading: true,
      appInfo: appInfo
    };
    base.callApi('/v2/order/add', 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
      if (data.status === 'true') {
        base.callApi('/v4/apply/apps?sw_ids=' + params.sw_id + '&&cloudStore=1', 'GET', {}, 'json', 'text').then(data => {
          this.applyApps = data;
          // message.success('申请成功');
          this.applyModal = {
            ...this.applyModal,
            loading: false
          };
        })
      } else {
        this.applyModal = {
          ...this.applyModal,
          visible: false
        };
        message.success(data.msg ? data.msg : '获取失败，请重试！');
        localStorage.removeItem('me');
        InitStore.me = {};
      }
    });
  }

  getApply(params, appInfo) {
    params.orderType = '3';
    let param = {
      order: JSON.stringify(params),
      access_token: getAccessToken(),
      cloudStore: 1,
    };
    this.applyModal = {
      ...this.applyModal,
      visible: true,
      loading: true,
      appInfo: appInfo
    };
    base.callApi('/v4/apply/apps?sw_ids=' + params.sw_id + '&&cloudStore=1', 'GET', {}, 'json', 'text').then(data => catchApiError(data, this.routing)).then(data => {
      this.applyApps = data;
      this.applyModal = {
        ...this.applyModal,
        loading: false
      };
    })
  }

  setTradeApplication(tradeApplication) {
    this.tradeApplication = tradeApplication;
  }

  doUpload(params = {}) {
    // if (!localStorage.me) {
    //   message.info("对不起，此功能暂无权限！请登录后使用！");
    // } else {
    //   let me = !!localStorage.me ? JSON.parse(localStorage.me) : {role: ""};
    //   base.callApi('/v3/', 'POST', param, 'json', 'text').then((data) => {
    //     }
    //   });
    // }
  }

  submitShare = (params = {}) => {
    params = {
      ...params,
      //  access_token: me.token.access_token,
      cloudStore: 1,
    };
    base.callApi('/v3/shareApps?access_token=' + getAccessToken(), 'POST', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
      if (data.status === '1') {
        message.success("提交成功");
        let temp = this.appShare.dataSourceForTable;
        this.appShare.selectedRows.forEach(o => {
          temp.forEach(v => {
            if (o.sw_id === v.sw_id) {
              v.trade = params.tradeName;
              v.function = params.functionName;
              v.isSubmit = true;
            }
          })
        })
        this.appShare = {
          ...this.appShare,
          selectedRowKeys: [],
          selectedRows: [],
          function: '',
          trade: '',
          functionName: '',
          tradeName: '',
          otherFunction: '',
          otherTrade: '',
          dataSourceForTable: temp
        };
      } else {
        message.success(data.msg ? data.msg : '提交失败');
      }
    });
  }

  clearShare = () => this.appShare = initState.appShare;

  getLastestShare(params = {}) {
    base.callApi('/v3/shareRank?access_token=' + getAccessToken(), 'GET', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
      this.lastestShare = data;
    });
  }
  @action
  view = (app) => {
    this.getAppDetail(app).then((data) => {
      if (data.app && data.app.s_ispreview === '1') {
        if (app.s_mobiurl) {
          window.open(`http://e8pc.e-cology.com.cn/mobilemode/apps/online/index_cs.html?url=${app.s_mobiurl}`, '_blank');
        } else if (app.s_pcurl) {
          window.open(`http://cloude8.e-cology.cn/login/login4wf.jsp?userid=1&gopage=${app.s_pcurl}`, '_blank');
        } else {
          window.open(`http://cloude8.e-cology.cn/login/login4wf.jsp?userid=1&gopage=/cloudstore/system/index.jsp#/${app.s_number}/set`, '_blank');
        }
      } else {
        message.info('该应用暂不支持预览');
      }
    });
  }
  @action
  getAppDetail = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      type: 'get',
    };
    return new Promise(resolve => {
      base.callApi(`/v1/app/${params.sw_id}`, 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status !== 'false') {
          resolve(data);
        }
      });
    });
  }

  @action
  addCollect = (params = {}) => {
    this.addCollectLoading = true;     //收藏按钮防抖
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi(`/v5/collect/addCollect`, 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status) {
          message.success(data.msg || "收藏成功");
        } else {
          // message.error(data.msg || '收藏失败')
        }
        resolve(data);
        this.addCollectLoading = false;
      });
    });
  }

  @action
  getDemoType = () => {
    return new Promise(resolve => {
      base.callApi(`/files/demoType.json`, 'GET', {}, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status) {
          message.success(data.msg || "收藏成功");
        } else {
          // message.error(data.msg || '收藏失败')
        }
        resolve(data);
      });
    });
  }

  @action
  getAllData = (params = {}, loading = true) => {
    this.allLoading = loading;
    const param = {
      ...this.allPageParams,
      demotype: this.demotype,
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise((resolve, reject) => {
      base.callApi("/v5/ecode/specifyList", 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        try {
          if (data.status) {
            this.allDatas = {[this.demotype]: data.demoList};
            this.allCount = data.count;
            let types = {};
            data.types.forEach(value => {
              const { demotype, ...otherValue } = value;
              types[demotype] = otherValue;
            });
            this.demoTypeObj = types;
            if(this.demotype === "") this.demotype = data.types[0].demotype;
          } else {
            message.error(data.msg || "接口错误");
          }
          this.allLoading = false;
          resolve(data);
        } catch(e) {
          console.error(e)
          this.allLoading = false;
        }
      });
    });
  }

  @action
  globalSearchList = (params = {}, loading = true) => {
    this.allLoading = loading;
    const param = {
      orderby: "createdate",
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise((resolve, reject) => {
      base.callApi(`/v5/ecode/globalSearchList`, 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        try {
          if (data.status) {
            this.allDatas = data.data;
            this.allCount = 0;
            let types = {};
            data.types.forEach(value => {
              const { demotype, ...otherValue } = value;
              types[demotype] = otherValue;
            });
            this.demoTypeObj = types;
          } else {
            message.error(data.msg || "接口错误")
          }
          this.allLoading = false;
          resolve(data);
        } catch(e) {
          console.error(e)
          this.allLoading = false;
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/home/HomeStore.js